import { swSlice, updateSw } from "#slices/swSlice.ts";
import { useAppSelector, useAppDispatch } from "@momentum/redux-store";
import { Toast } from "radix-ui";

export function ServiceWorkerToast() {
  const swState = useAppSelector(swSlice.selectSlice);
  const offlineReady = swState.offlineReady;
  const needRefresh = swState.needRefresh;
  const dispatch = useAppDispatch();

  return (
    <>
      <Toast.Root
        className="bg-lvl-1 p-4 shadow-md rounded border border-grey-15"
        open={offlineReady || needRefresh}
        duration={needRefresh ? Infinity : undefined}
      >
        {offlineReady ? (
          <>
            <Toast.Title>Offline ready</Toast.Title>
            <Toast.Description>
              The application is ready to work offline.
            </Toast.Description>
          </>
        ) : (
          <>
            <Toast.Title>New version available</Toast.Title>
            <Toast.Description>
              Please refresh the page to get the new version.
            </Toast.Description>
            <Toast.Action altText="Refresh" asChild>
              <button onClick={() => dispatch(updateSw())}>Reload</button>
            </Toast.Action>
          </>
        )}
      </Toast.Root>
    </>
  );
}
